import Swal from "sweetalert2";
import { runQuick_Action_Uploadfile_Api } from "../../Apis/user/ApiConfig";
import {
  RUN_QUICK_ACTION_REMOVE_FILE_SUCCESS,
  RUN_QUICK_ACTION_UPLOAD_FILE_ERROR,
  RUN_QUICK_ACTION_UPLOAD_FILE_REQUEST,
  RUN_QUICK_ACTION_UPLOAD_FILE_SUCCESS,
  RUN_QUICK_ACTION_REMOVE_ARRAY_SUCCESS,
} from "../../Types/user/Types";

export const Run_QuickAction_uploadFile_Success = (res) => {
  return {
    type: RUN_QUICK_ACTION_UPLOAD_FILE_SUCCESS,
    payload: res,
  };
};
export const Run_QuickAction_uploadFile_Error = (error) => {
  return {
    type: RUN_QUICK_ACTION_UPLOAD_FILE_ERROR,
    error: error,
  };
};
export const Run_QuickAction_uploadFile_Request = (res) => {
  return {
    type: RUN_QUICK_ACTION_UPLOAD_FILE_REQUEST,
    payload: res,
  };
};

export const Run_QuickAction_Remove_File_Success = (index) => {
  return {
    type: RUN_QUICK_ACTION_REMOVE_FILE_SUCCESS,
    payload: index,
  };
}
export const Run_QuickAction_Remove_Array_Success = () => {
  return {
    type: RUN_QUICK_ACTION_REMOVE_ARRAY_SUCCESS,
    payload: '',
  };
}
export const Run_QuickAction_uploadFile_ActionHandler = (file, id) => {
  return (dispatch) => {
    dispatch(Run_QuickAction_uploadFile_Request());
    try {
      runQuick_Action_Uploadfile_Api(file, id)
        .then((res) => {
          const errorMessage = res?.data?.message;
          if (res) {
            if (res && res.data && res.status === 201) {
              dispatch(Run_QuickAction_uploadFile_Success(res.data));
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "something went Wrong!",
              });
              dispatch(Run_QuickAction_uploadFile_Error(errorMessage));
            }
          } else {
            dispatch(Run_QuickAction_uploadFile_Error(errorMessage));
          }
        })
        .catch((err) => {
          dispatch(Run_QuickAction_uploadFile_Error("Something Went Wrong!!!"));
        });
    } catch (err) {
      dispatch(Run_QuickAction_uploadFile_Error(err));
    }
  };
};
